const newsletterConfettiColors = ['#EB0A1E', '#ffffff', '#000000', '#ABC4CA']

function celebrateNewsletter() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const canvas = document.createElement('canvas')
  canvas.setAttribute('aria-hidden', 'true')
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:10000'
  document.body.appendChild(canvas)

  const context = canvas.getContext('2d')
  if (!context) {
    canvas.remove()
    return
  }

  const ratio = window.devicePixelRatio || 1
  const width = window.innerWidth
  const height = window.innerHeight
  canvas.width = width * ratio
  canvas.height = height * ratio
  context.setTransform(ratio, 0, 0, ratio, 0, 0)

  const origins = [
    { x: 0.2, y: 0.65, delay: 0 },
    { x: 0.8, y: 0.65, delay: 8 },
    { x: 0.5, y: 0.4, delay: 16 },
  ]
  const particles = []

  origins.forEach((origin) => {
    for (let index = 0; index < 70; index += 1) {
      const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.5
      const speed = 7 + Math.random() * 9
      particles.push({
        x: width * origin.x,
        y: height * origin.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: 6 + Math.random() * 6,
        color: newsletterConfettiColors[index % newsletterConfettiColors.length],
        rotation: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 0.28,
        delay: origin.delay,
        life: 0,
      })
    }
  })

  function frame() {
    context.clearRect(0, 0, width, height)
    let alive = false

    particles.forEach((particle) => {
      if (particle.delay > 0) {
        particle.delay -= 1
        alive = true
        return
      }

      particle.life += 1
      if (particle.life > 150) return

      alive = true
      particle.vy += 0.16
      particle.x += particle.vx
      particle.y += particle.vy
      particle.vx *= 0.992
      particle.rotation += particle.spin

      context.save()
      context.translate(particle.x, particle.y)
      context.rotate(particle.rotation)
      context.globalAlpha = Math.max(0, 1 - particle.life / 150)
      context.fillStyle = particle.color
      context.fillRect(-particle.size / 2, -particle.size / 3, particle.size, particle.size * 0.55)
      context.restore()
    })

    if (alive) {
      window.requestAnimationFrame(frame)
      return
    }

    canvas.remove()
  }

  window.requestAnimationFrame(frame)
}

const newsletterDialogVars = [
  '--nl-heading-family',
  '--nl-heading-weight',
  '--nl-body-family',
  '--nl-body-size',
  '--nl-body-weight',
  '--nl-btn-bg',
  '--nl-btn-color',
  '--nl-btn-bg-hover',
  '--nl-btn-radius',
  '--nl-btn-family',
  '--nl-btn-weight',
]

function findNewsletterDialog(newsletter) {
  const inSection = newsletter.querySelector('.newsletter__success')
  if (inSection) return inSection

  const section = newsletter.closest('[id^="shopify-section-"]')
  const sectionId = section ? section.id.replace('shopify-section-', '') : ''
  if (!sectionId) return null

  return document.querySelector(`.newsletter__success[data-newsletter-success="${CSS.escape(sectionId)}"]`)
}

const newsletterCloseTimers = new WeakMap()

function clearNewsletterTimer(dialog) {
  const timeout = newsletterCloseTimers.get(dialog)
  if (!timeout) return
  window.clearTimeout(timeout)
  newsletterCloseTimers.delete(dialog)
}

function startNewsletterTimer(dialog) {
  clearNewsletterTimer(dialog)

  if (!dialog.hasAttribute('data-auto-close')) return

  const bar = dialog.querySelector('.newsletter__success-timer')
  if (!bar) return

  const seconds = Number(dialog.dataset.closeDuration)
  const duration = Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : 5000
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const motionDuration = reduceMotion ? '0.01ms' : `${duration}ms`

  bar.style.setProperty('--newsletter-success-duration', '0ms')
  bar.value = 100

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      bar.style.setProperty('--newsletter-success-duration', motionDuration)
      bar.value = 0
    })
  })

  const timeout = window.setTimeout(() => {
    newsletterCloseTimers.delete(dialog)
    if (typeof dialog.hide === 'function') dialog.hide()
  }, duration)

  newsletterCloseTimers.set(dialog, timeout)
}

function presentNewsletterDialog(dialog, newsletter) {
  const styles = window.getComputedStyle(newsletter)
  newsletterDialogVars.forEach((name) => {
    const value = styles.getPropertyValue(name).trim()
    if (value) dialog.style.setProperty(name, value)
  })

  if (dialog.parentElement !== document.body) {
    document.body.appendChild(dialog)
  }

  if (!dialog.dataset.closeBound) {
    dialog.dataset.closeBound = 'true'
    dialog.addEventListener('sl-hide', () => {
      clearNewsletterTimer(dialog)
      const bar = dialog.querySelector('.newsletter__success-timer')
      if (bar) {
        bar.style.setProperty('--newsletter-success-duration', '0ms')
        bar.value = 100
      }
    })
  }

  dialog.style.zIndex = '800'

  if (dialog.open) {
    startNewsletterTimer(dialog)
    return
  }

  dialog.addEventListener('sl-after-show', () => startNewsletterTimer(dialog), { once: true })
  dialog.show()
}

document.addEventListener('klaviyo-form:success', (event) => {
  const newsletter = event.target.closest('.newsletter')
  if (!newsletter) return

  event.preventDefault()

  const dialog = findNewsletterDialog(newsletter)
  if (dialog && typeof dialog.show === 'function') {
    presentNewsletterDialog(dialog, newsletter)
  }

  if (newsletter.hasAttribute('data-confetti')) {
    celebrateNewsletter()
  }
})
